import gql from 'graphql-tag';

export default {
    install: function(Vue) {
        Vue.$router.onReady(async () => {
            let referrer;
            const partner = Vue.$router.currentRoute.query.partner;

            if (document.referrer && document.referrer.includes(window.origin) === false) {
                referrer = document.referrer;
            }

            if (partner) {
                Vue.$router.replace({
                    name: Vue.$router.currentRoute.name,
                    params: Vue.$router.currentRoute.params,
                    query: {
                        ...Vue.$router.currentRoute.query,
                        partner: undefined,
                    },
                });
                Vue.$store.dispatch('Checkout/applyPartner', partner);
            } else if (referrer) {
                try {
                    const { data } = await Vue.$graphql.query({
                        query: gql`
                            query partnerGetByReferrer($referrer: String!) {
                                partnerGetByReferrer(referrer: $referrer) {
                                    partner_shortcut
                                }
                            }
                        `,
                        variables: {
                            referrer,
                        },
                    });
                    if (data.partnerGetByReferrer.partner_shortcut) {
                        Vue.$store.dispatch('Checkout/applyPartner', data.partnerGetByReferrer.partner_shortcut);
                    }
                } catch (err) {}
            }
            if (Vue.$router.currentRoute.query.prime_campaign) {
                Vue.$store.dispatch('Checkout/applyPrimeCampaign', Vue.$router.currentRoute.query.prime_campaign);
            }
            if (!Vue.$router.currentRoute.meta.preventReferrerChange && referrer) {
                Vue.$store.dispatch('Checkout/applyReferrer', referrer);
            }
        });
    },
};
